import api from './api';
import {mapUserDto} from "../dto/UserDTO";

export const getMe = async () => {
    try {
        const res = await api.get('/User/me');
        return res.data;
    } catch (err) {
        console.error("Error fetching own profile:", err);
        throw err;
    }
};

export const getAllUsers = async () => {
    try {
        const res = await api.get('/User');
        return res.data.map(mapUserDto);
    } catch (err) {
        console.error("Error receiving user:", err);
        throw err;
    }
};

export const deleteUser = async (user_id) => {
    try {
        const res = await api.delete(`/User/${user_id}`);
        return res.data;
    } catch (err) {
        console.error("Error deleting user:", err);
        throw err;
    }
}

export const changePassword = async (userId, newPassword, currentPassword) => {
    try {
        const body = { password_clear: newPassword };
        if (currentPassword) body.current_password = currentPassword;
        const res = await api.patch(`/User/${userId}/password`, body);
        return res.data;
    } catch (err) {
        console.error("Error changing password:", err);
        throw err;
    }
};

export const changeUserActiveState = async (userId, isActive) => {
    try {
        const res = await api.patch(`/User/user_active_state_change/${userId}/${isActive}`, {});
        return res.data;
    } catch (err) {
        console.error("Error changing user active state user:", err);
        throw err;
    }
};

/** "Dauerhaft OK": the user's overtime is approved as it is recorded. */
export const setOvertimeAutoApprove = async (userId, enabled) => {
    try {
        const res = await api.patch(`/User/${userId}/overtime-auto-approve/${enabled}`, {});
        return res.data;
    } catch (err) {
        console.error("Error changing overtime auto-approval:", err);
        throw err;
    }
};

export const addUser = async ({username, name, passwordClear, email, role}) => {
    try {
        const res = await api.post('/User', {username, name, password_clear: passwordClear, email, role});
        return res.data;
    } catch (err) {
        console.error("Error creating user:", err);
        throw err;
    }
};

export const updateProfile = async (userId, { username, email }) => {
    try {
        const res = await api.patch(`/User/${userId}/profile`, { username, email });
        return res.data;
    } catch (err) {
        console.error("Error updating profile:", err);
        throw err;
    }
};

export const updateUser = async (userId, dto) => {
    try {
        const res = await api.patch(`/User/${userId}`, dto);
        return res.data;
    } catch (err) {
        console.error("Error updating user:", err);
        throw err;
    }
};

export const getProjectsForUser = async ({userId}) => {
    try {
        const res = await api.get(`/User/${userId}/Projects`);
        return res.data;
    } catch (err) {
        console.error("Error get projects for user:", err);
        throw err;
    }
};